import React from 'react';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';

const Wrapper = styled.div`
  margin-top: 100px;
  padding-bottom: 200px;

  @media (min-width: 768px) {
    margin-top: 200px;
  }
  @media (min-width: 992px) {
    margin-top: 300px;
  }
  @media (min-width: 1200px) {
    margin-top: 400px;
  }
`;

const CenteredCol = styled(Col)`
  text-align: center;
`;

const LogoImage = styled.img`
  width: 80%;
  margin: 20px auto;
  opacity: 0.5;

  transition: opacity 0.5s;
  
  &:hover {
    opacity: 1;
  }
`;

const ClientLogos = () => (
  <Wrapper>
    <Container>
      <Row>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/gloo.png" alt="Gloo" title="Gloo" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/digitalglobe.png" alt="Digital Globe" title="Digital Globe" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/nasa.png" alt="NASA" title="NASA" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/bacardi.png" alt="Bacardi" title="Bacardi" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/sxsw.png" alt="SXSW" title="SXSW" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/techstars.png" alt="Techstars" title="Techstars" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/flux.png" alt="Flux" title="Flux" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/faculty.png" alt="Faculty" title="Faculty" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/dolectures.png" alt="Do Lectures" title="Do Lectures" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/lacuna.png" alt="Lacuna" title="Lacuna" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/quickleft.png" alt="QuickLeft" title="QuickLeft" />
        </CenteredCol>
        <CenteredCol xs="4" md="3" lg="2">
          <LogoImage src="/images/clients/re3d.png" alt="re3D" title="re3D" />
        </CenteredCol>
      </Row>
    </Container>
  </Wrapper>
);

export default ClientLogos;



// WEBPACK FOOTER //
// ./src/components/ui/ClientLogos.js